<script setup lang="ts">
import { settings } from '@/content'
const phone = settings.phones[0]
</script>

<template>
  <a :href="`tel:${phone.tel}`" class="fcall" :aria-label="`Appeler le ${phone.display}`">
    <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor" aria-hidden="true">
      <path d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.5.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1C10.7 21 3 13.3 3 4c0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.2.2 2.4.6 3.5.1.4 0 .8-.2 1l-2.3 2.3z" />
    </svg>
    <span>Appeler</span>
  </a>
</template>

<style scoped>
.fcall {
  position: fixed;
  right: 16px;
  bottom: 16px;
  z-index: 90;
  display: none;
  align-items: center;
  gap: 8px;
  padding: 14px 18px;
  background: var(--green);
  color: #272a23;
  border-radius: 999px;
  font-family: var(--font-title);
  font-weight: 700;
  text-transform: uppercase;
  font-size: 0.85rem;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.25);
}
.fcall:hover {
  background: var(--green-hover);
  text-decoration: none;
}
@media (max-width: 720px) {
  .fcall {
    display: inline-flex;
  }
}
</style>
